import { FC } from "react";

import { MarketShipmentHistory } from "@/features/MarketShipmentHistory";

interface HistoryTabProps {
    marketId: string;
}

export const HistoryTab: FC<HistoryTabProps> = ({ marketId }) => {
    return <MarketShipmentHistory marketId={marketId} />;
};
